import {
  createDirectFedexCarrierAccountInputSchema,
  createDirectFedexCarrierAccountOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/fedex-customer-registration";

export const createDirectFedexCarrierAccount = {
  name: "createDirectFedexCarrierAccount" as const,
  input: createDirectFedexCarrierAccountInputSchema,
  output: createDirectFedexCarrierAccountOutputSchema,
};
